import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Select from "react-select";
import { adminMainUrl } from "../../../../../../../Config";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getCCJobOrderExportInvoiceDetail } from "../../../../../../../Redux/action/CustomClearance/CCAction";

const EditInvoice = ({
  addShow,
  handleAddClose,
  token,
  user_id,
  b64id,
  refresh,
  loadingCCExpJobCurrencyList,
  currencyOptions,
  invoice_id
}) => {

  const dispatch = useDispatch();
  const [disableSubmit, setDisableSubmit] = useState(false);


  useEffect(() => {
    if (token && user_id && b64id && (invoice_id && invoice_id != 0)) {
      let id = atob(b64id);
      if (id) {
        dispatch(getCCJobOrderExportInvoiceDetail(token, user_id, id, invoice_id))
      }
    }
  }, [invoice_id]);

  const {
    loadingCCExpJobInvoiceDetail,
    CCExpJobInvoiceDetailData,
    CCExpJobInvoiceDetailDataError,
  } = useSelector(state => state?.CCReducer);




  const initialValues = {
    custom_clearance_export_job_id: "",
    invoice_no: "",
    invoice_date: "",
    TOI_type: "",
    TOI_place: "",
    currency_type: "",
    currency_amount: "",
    price_includes: "",
    taxable_value_for_IGST: "",
    invoice_value: "",
    product_value: "",
    packing_FOB: ""
  }

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values,{resetForm}) => {
      // console.log(values);
      setDisableSubmit(true);
      try {
        let config = {
          headers: {
            'auth-token': token,
            'user_id': user_id
          }
        };

        values.custom_clearance_export_job_id = atob(b64id);
        values.id = invoice_id
        axios.post(`${adminMainUrl}/api/customClearance/invoice/update`, values, config)
          .then(response => {
            if (response.status == 200) {
              toast.success(response?.data?.msg);
              setDisableSubmit(false);
              handleAddClose();
              // resetForm();
              refresh();
            } else {
              toast.error(response?.data?.msg);
              setDisableSubmit(false);
            }
          }).catch(error => {
            console.log(error);
            let msg = "Internal server error!";
            if (error.response && error.response.data && error.response.data.msg) {
              msg = error.response.data.msg
            }
            toast.error(msg);
            setDisableSubmit(false);
          })
      } catch (error) {
        console.log(error.message);
        toast.error(error.message);
        setDisableSubmit(false);
      }
    }
  });

  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    if (loadingCCExpJobInvoiceDetail) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }

    if (CCExpJobInvoiceDetailData) {
      formik.setFieldValue("invoice_no", CCExpJobInvoiceDetailData?.invoice_no);
      formik.setFieldValue("invoice_date", CCExpJobInvoiceDetailData?.invoice_date);
      formik.setFieldValue("TOI_type", CCExpJobInvoiceDetailData?.TOI_type);
      formik.setFieldValue("TOI_place", CCExpJobInvoiceDetailData?.TOI_place);
      formik.setFieldValue("currency_type", Number(CCExpJobInvoiceDetailData?.currency_type));
      formik.setFieldValue("currency_amount", CCExpJobInvoiceDetailData?.currency_amount);
      formik.setFieldValue("price_includes", CCExpJobInvoiceDetailData?.price_includes);
      formik.setFieldValue("taxable_value_for_IGST", CCExpJobInvoiceDetailData?.taxable_value_for_IGST);
      formik.setFieldValue("invoice_value", CCExpJobInvoiceDetailData?.invoice_value);
      formik.setFieldValue("product_value", CCExpJobInvoiceDetailData?.product_value);
      formik.setFieldValue("packing_FOB", CCExpJobInvoiceDetailData?.packing_FOB);
    }
  }, [loadingCCExpJobInvoiceDetail, CCExpJobInvoiceDetailData])

  return (
    <>
      <Offcanvas show={addShow} onHide={handleAddClose} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit Invoice</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-6 mt-2">
                <label htmlFor="pickuptype" className="form-label  ">
                  Invoice No.
                </label>
                <input name="invoice_no"
                  id="invoice_no"
                  maxLength={250}
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.invoice_no}
                />
              </div>
              <div className="col-md-6 mt-2">
                <label htmlFor="pickuptype" className="form-label  ">
                  Date
                </label>
                <input
                  type="date"
                  name="invoice_date"
                  id="invoice_date"
                  className="form-control form-control-sm "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.invoice_date}
                />
              </div>
              <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      TOI &
                    </label>
                    <select
                      type="text"
                      maxLength={250}
                      className="form-control form-control-sm"
                      name="TOI_type"
                      id="TOI_type"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.TOI_type}
                    >
                      <option value="" disabled>-</option>
                      <option value="FOB">FOB</option>
                      <option value="CIF">CIF</option>
                      <option value="C&F">C&F</option>
                      <option value="C&I">C&I</option>

                    </select>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Place
                    </label>
                    <input
                      name="TOI_place"
                      id="TOI_place"
                      className="form-control form-control-sm "
                      maxLength={250}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.TOI_place}
                    />
                  </div>
                </div>

              </div>
              <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Currency
                    </label>

                    <Select
                      className="custom-selector"
                      placeholder="Select Currency"
                      name="currency_type"
                      options={currencyOptions}
                      onChange={option => {
                        formik.setFieldValue('currency_type', option.value);
                      }}
                      value={currencyOptions.find(option => option.value === formik.values.currency_type) || null}
                      isLoading={loadingCCExpJobCurrencyList}
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Amount
                    </label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      maxLength={30}
                      name="currency_amount"
                      id="currency_amount"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.currency_amount}
                      onInput={(event) => {
                        let value = event.target.value;
                        value = value.replace(/[^0-9]/g, '');
                        event.target.value = value;
                      }}
                    />
                  </div>

                </div>

              </div>
              <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Price Includes
                    </label>
                    <select
                      className="form-control form-control-sm"
                      name="price_includes"
                      id="price_includes"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.price_includes}
                    >
                      <option value="" disabled>-</option>
                      <option value="None">None</option>
                      <option value="Freight">Freight</option>
                      <option value="Insurance">Insurance</option>
                      <option value="Both">Both</option>

                    </select>
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Taxable value for IGST
                    </label>
                    <select
                      className="form-control form-control-sm"
                      name="taxable_value_for_IGST"
                      id="taxable_value_for_IGST"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.taxable_value_for_IGST}
                    >
                      <option value="" disabled>-</option>
                      <option value="Product Value">Product Value</option>
                      <option value="Product FOB">Product FOB</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-md-6 mt-2">
                <label htmlFor="pickuptype" className="form-label  ">
                  Invoice Value
                </label>
                <input
                  className="form-control form-control-sm"
                  type="text"
                  name="invoice_value"
                  id="invoice_value"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.invoice_value}
                  maxLength={30}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
                />
              </div>

              <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Product Value
                    </label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      name="product_value"
                      id="product_value"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.product_value}
                      maxLength={30}
                      onInput={(event) => {
                        let value = event.target.value;
                        value = value.replace(/[^0-9]/g, '');
                        event.target.value = value;
                      }}
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      In
                    </label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      value={"FOB"}
                    />
                  </div>
                </div>

              </div>
              <div className="col-md-6 mt-2">
                <label htmlFor="pickuptype" className="form-label  ">
                  Packing/FOB
                </label>
                <input
                  className="form-control form-control-sm"
                  type="text"
                  name="packing_FOB"
                  id="packing_FOB"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.packing_FOB}
                  maxLength={30}
                  onInput={(event) => {
                    let value = event.target.value;
                    value = value.replace(/[^0-9]/g, '');
                    event.target.value = value;
                  }}
                />
              </div>
            </div>

            <div className="row d-flex justify-content-end mt-2">
              <div className="col-md-6 d-flex justify-content-end">
                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                  {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Edit"}
                </button>
              </div>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default EditInvoice
